const CalculateDaysBetween2Dates = (date1: any, date2: any) => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const firstDate: any = new Date(date1);
  const secondDate: any = new Date(date2);

  return Math.round(Math.abs((firstDate - secondDate) / oneDay));
};
export default CalculateDaysBetween2Dates;
